import React from 'react';

/**
 * Componente que gestiona la visualización de la cámara para escaneo móvil
 * 
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.scanning - Estado actual de escaneo (activo/inactivo)
 * @param {Function} props.setScanning - Función para cambiar el estado de escaneo
 * @param {Object} props.cameraStatus - Estado de la cámara (active, error)
 * @param {React.RefObject} props.scannerRef - Referencia al elemento donde se mostrará la cámara
 * @returns {JSX.Element} - Componente de la cámara de escaneo
 */
const ScannerCamera = ({
  scanning,
  setScanning,
  cameraStatus,
  scannerRef
}) => {
  const handleRetryScanner = () => {
    // Fuerza reinicio del flujo de Quagga incluso si scanning ya estaba en true.
    setScanning(false);
    setTimeout(() => {
      setScanning(true);
    }, 150);
  };

  return (
    <>
      {/* Contenedor adicional para aislar el scanner */}
      <div className="scanner-isolation-container">
        <div className="scanner-camera-wrapper">
          <div ref={scannerRef} className="scanner-view">
            {/* Camera will render here */}
            {!cameraStatus.active && !cameraStatus.error && (
              <div className="scanner-camera-placeholder">
                <i className="fa-solid fa-camera-slash"></i>
                <p>Escáner de códigos inactivo</p>
                <button
                  className="scanner-activate-button"
                  onClick={() => setScanning(true)}
                >
                  <i className="fa-solid fa-play"></i> Activar Escáner
                </button>
              </div>
            )}
            {cameraStatus.error && (
              <div className="scanner-camera-error">
                <i className="fa-solid fa-exclamation-triangle"></i>
                <p>Error de cámara: {cameraStatus.error}</p>
                <button
                  className="scanner-button"
                  onClick={handleRetryScanner}
                >
                  Reintentar
                </button>
              </div>
            )}
          </div>
          <div
            className={`scanner-viewfinder ${scanning ? "scanning-active" : ""}`}
          >
            <div className="scanner-viewfinder-corner-tl"></div>
            <div className="scanner-viewfinder-corner-br"></div>
            <div className="scanner-scan-line"></div>
          </div>

          <div className="scanner-camera-controls">
            <button
              className={`scanner-toggle-button ${scanning ? "active" : ""}`}
              onClick={() => setScanning(!scanning)}
            >
              {scanning ? (
                <>
                  <i className="fa-solid fa-pause"></i> Pausar Escáner
                </>
              ) : (
                <>
                  <i className="fa-solid fa-play"></i> Activar Escáner
                </>
              )}
            </button>

            <div className="scanner-camera-status">
              <span
                className={`scanner-status-indicator ${
                  cameraStatus.active ? "active" : "inactive"
                }`}
              ></span>
              {cameraStatus.active ? "Escáner activo" : "Escáner inactivo"}
            </div>
          </div>
        </div>
      </div>
      <div className="scanner-instructions">
        <h3>Instrucciones</h3>
        <ul>
          <li>Apunte la cámara al código de barras</li>
          <li>Mantenga el código a una distancia de 10-20 cm</li>
          <li>Asegúrese de buena iluminación</li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(ScannerCamera);